import { AnalyticCountModel } from '../../models/AnalyticCount.model';
import { SystemInsightsModel } from '../../models/SystemInsights.model';
import { UserInsightsModel } from '../../models/UserInsights.model';
import { InsightsFilter } from '../../types/AnalyticsTypes';

export type AnalyticCounts = {
  CONTENT: AnalyticCountModel;
  NOTIFICATION: AnalyticCountModel;
  USER: AnalyticCountModel;
  GUEST: AnalyticCountModel;
};

export enum LogDateFilterType {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  LIFETIME = 'LIFETIME',
  RANGE = 'RANGE',
}

export type FeedItemAnalyticQuery = {
  filter?: LogDateFilterType;
  range?: Date[];
};

export type FeedItemActivityLogQuery = {
  offset?: number;
};

export type UserInsightData = {
  [InsightsFilter.ALL_TIME]: UserInsightsModel;
  [InsightsFilter.WEEKLY]: UserInsightsModel;
};

export type SystemInsightsData = {
  [InsightsFilter.ALL_TIME]: SystemInsightsModel;
  [InsightsFilter.WEEKLY]: SystemInsightsModel;
};
